/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Defaultdataerror2Inputs */

const en_common_defaultdataerror2 = /** @type {(inputs: Common_Defaultdataerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: Unable to retrieve data. Please check your internet connection and try again later.`)
};

/**
* | output |
* | --- |
* | "Error: Unable to retrieve data. Please check your internet connection and try again later." |
*
* @param {Common_Defaultdataerror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_defaultdataerror2 = /** @type {((inputs?: Common_Defaultdataerror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Defaultdataerror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_defaultdataerror2(inputs)
});
export { common_defaultdataerror2 as "common_defaultDataError" }